import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {AdminFile} from "apis/Admin";

// First, create the thunk
export const addNewsRequest = createAsyncThunk("addNews", async (args) => {
  const response = await AdminFile.post("news/create", args);
  return response.data;
});

//edit news
export const editNewsRequest = createAsyncThunk("editNews", async (args) => {
  const response = await AdminFile.put("news/edit", args);
  return response.data;
});

// Then, handle actions in your reducers:
const addNewsSlice = createSlice({
  name: "addNews",
  initialState: { message: "",  loading: false },
  reducers: { },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [addNewsRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, message: action.payload.message, loading: false };
    },
    [addNewsRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [addNewsRequest.rejected]: (state, _action) => {
      return {
        ...state,
        message: "Failed",
        loading: false,
      };
    },
    [editNewsRequest.fulfilled]: (state, action) => {
      // Add key to the state array
      return { ...state, message: action.payload.message, loading: false };
    },
    [editNewsRequest.pending]: (state) => {
      return { ...state, loading: true };
    },
    [editNewsRequest.rejected]: (state, _action) => {
      return {
        ...state,
        message: "Failed",
        loading: false,
      };
    },
  },
});



export default addNewsSlice.reducer;
